module.exports = __webpack_public_path__ + "static/img/logo-large-white.d8d50ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/index/logo-large-white.png
// module id = J868
// module chunks = 8